// extracted by mini-css-extract-plugin
var _1 = "ogcdvOgW";
var _2 = "ogcdvOgW";
export { _1 as "rating-star", _2 as "ratingStar" }
